import { atom } from 'jotai';

const hilightDimensionAtom = atom<{ backendName: string, level: number }>([]);
const displayConfigAtom = atom(false);
const isConfigLoadingAtom = atom(true);
const totalCombinationsAtom = atom(0);

export {
  hilightDimensionAtom,
  displayConfigAtom,
  isConfigLoadingAtom,
  totalCombinationsAtom
};
